export default {"src":"/_next/static/media/onboarding-checkbox-logo.de264c2f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};